import { initModule } from './init-module';

initModule();

export { NotificationModal } from './components/reusable-components/notificationModal.component';

export { AccountManagementContainer } from './components/reusable-components/acctMgmtContainer.component';

export { AccountManagementRoutes } from './account-management.routes';

export { accountManagementLibrary } from './account-management.config';
